module.exports = __webpack_public_path__ + "static/media/taco.d18bd66b.svg";